import { PrizeSlugToEnterPage } from './PrizePageEnterMapping';

export const getEnterLinkForPrize = (
  prizeSlug: string,
  utmSource?: string
): string | null => {

  if (!utmSource){
    return null
  }
  
  const normalizedPrizeSlug = prizeSlug.toLowerCase();
  const normalizedUtmSource = utmSource.toLowerCase();

  const prizeInfo = PrizeSlugToEnterPage[normalizedPrizeSlug];

  if (prizeInfo && prizeInfo[normalizedUtmSource]) {
    // Exact prize and UTM source match found
    return prizeInfo[normalizedUtmSource];
  }
  return null;
};